/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServiceInfoRespVo } from './AdditionalServiceInfoRespVo';
import {
    AdditionalServiceInfoRespVoFromJSON,
    AdditionalServiceInfoRespVoFromJSONTyped,
    AdditionalServiceInfoRespVoToJSON,
    AdditionalServiceInfoRespVoToJSONTyped,
} from './AdditionalServiceInfoRespVo';

/**
 * 
 * @export
 * @interface ResponseAdditionalServiceInfoRespVo
 */
export interface ResponseAdditionalServiceInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdditionalServiceInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdditionalServiceInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {AdditionalServiceInfoRespVo}
     * @memberof ResponseAdditionalServiceInfoRespVo
     */
    data?: AdditionalServiceInfoRespVo;
}

/**
 * Check if a given object implements the ResponseAdditionalServiceInfoRespVo interface.
 */
export function instanceOfResponseAdditionalServiceInfoRespVo(value: object): value is ResponseAdditionalServiceInfoRespVo {
    return true;
}

export function ResponseAdditionalServiceInfoRespVoFromJSON(json: any): ResponseAdditionalServiceInfoRespVo {
    return ResponseAdditionalServiceInfoRespVoFromJSONTyped(json, false);
}

export function ResponseAdditionalServiceInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdditionalServiceInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdditionalServiceInfoRespVoFromJSON(json['data']),
    };
}

export function ResponseAdditionalServiceInfoRespVoToJSON(json: any): ResponseAdditionalServiceInfoRespVo {
    return ResponseAdditionalServiceInfoRespVoToJSONTyped(json, false);
}

export function ResponseAdditionalServiceInfoRespVoToJSONTyped(value?: ResponseAdditionalServiceInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdditionalServiceInfoRespVoToJSON(value['data']),
    };
}

